import React from "react";
import { createRoot } from "react-dom/client";
import './css/vat.scss';
import VATFormFlow from "./vat/VATFormFlow";

const container = document.getElementById("vat-inject");
if (container) {
  const root = createRoot(container);
  root.render(<VATFormFlow />);
}